export default "__VITE_ASSET__bbcc9e6d__"